import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustMarquee } from "@/components/TrustMarquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Process } from "@/components/Process";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

const Landing = () => (
  <ReactLenis
    root
    options={{ lerp: 0.09, wheelMultiplier: 1 }}
    ref={(instance) => {
      window.__lenis = instance?.lenis || instance || null;
    }}
  >
    <div className="App">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <About />
        <Services />
        <WhyUs />
        <BeforeAfter />
        <Process />
        <Booking />
      </main>
      <Footer />
    </div>
  </ReactLenis>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/admin"
          element={
            <div className="App">
              <Admin />
            </div>
          }
        />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#14242F",
            border: "1px solid rgba(255,255,255,0.15)",
            color: "#fff",
            fontFamily: "Mukta, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
